<template>
<div v-show="isModalVisible">
  <div class="modal-mask" @dragover.prevent @drop="onDrop">
      <div class="modal-container">
        <!-- Modal Header -->
        <div class="modal-header">
          <h6 class="modal-title"></h6>
        </div>
        <!-- Modal body -->
        <div class="modal-body pt-0"  >
          <div class="row">
            <div class="col-12 text-center pb-4">
              <img class="" style="" height="33px" src="@/assets/manager/file_drop_icon.png" />
            </div>
            <div class="col-12 text-center">
              Drag a pathway from the menu on the right
            </div>
            <div class="col-12" v-for="item in targetItems" :key="item.id">
              <div class="catalog-border">
                <div class="row">
                  <div class="col-2 text-center pr-0" style="text-align: left !important; padding: 0px 0px 0px 0px !important; width: 5%;" >
                    <img class="mr-2 ml-4" style="" height="17px" src="@/assets/manager/tasks_icon_rep_audit_trail.png" />
                  </div>
                  <div class="col-10 pl-0">
                    {{ item.title }}
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 text-center pt-5" v-if="stepsObj.length >= 1">
              <button class="btn ma-blue-btn btn-md input-height-15 pathwayBtn mr-2" @click="submitPathway()"
										>Add Pathway</button>  
            </div>
          </div>
        </div>
      </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';

export default {
  props: [
    'isModalVisible'
    ],
  data() {
    return {
      loading: false,
      targetItems: [],
      stepsObj: [],
    }
  },
  methods: {
    getFontIconSub(id) {
        if (document.getElementById('collapse-sub-' + id).style.display == "") {
            document.getElementById('angle-sub-'+ id).className = "fa fa-angle-right";
        } else {
            document.getElementById('angle-sub-'+ id).className = "fa fa-angle-down";
        }
    },
    onDrop(event) {
      const itemid = event.dataTransfer.getData('itemId');
      const steps = event.dataTransfer.getData('steps');
      const receivedArray = JSON.parse(steps);
      this.stepsObj = receivedArray;
      console.log(this.stepsObj);
      const itemName = event.dataTransfer.getData('itemName');
      this.targetItems = [];
      this.targetItems.push({
        id: itemid,
        title: itemName,
        steps: receivedArray,
      });
      if(this.stepsObj.length >= 1) {
        this.$parent.callButtonCatalogClose();
      }
    },
    closeModal() {
      this.$emit('close');
    },
    submitPathway() {
      this.$store.dispatch('catalog_pathway_steps', '');
      this.$store.dispatch('catalog_pathway_steps', this.stepsObj);
      this.$parent.closeCatalogListsAfterDragDrop();
    },
  },
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
}
  .modal-container {
    position: fixed;
    left: 25.84%;
    top: 55%;
    -ms-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 400px;
    height: 450px;
    overflow-y: auto;
    padding: 20px 30px;
    border: 1px dashed #002F42;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
  }
	@media (max-width: 1690px) and (min-width: 1605px) {
    .modal-container {
      position: fixed;
      left: 24.77%;
      top: 46%;
      -ms-transform: translate(-50%, -50%);
      -moz-transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      width: 400px;
      height: 450px;
      overflow-y: auto;
      padding: 20px 30px;
      border: 1px dashed #002F42;
      background-color: #fff;
      border-radius: 10px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
      transition: all .3s ease;
    }
	}
	@media (max-width: 1400px) {
    .modal-container {
      position: fixed;
      left: 28.33%;
      top: 60%;
      -ms-transform: translate(-50%, -50%);
      -moz-transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      width: 360px;
      height: 380px;
      overflow-y: auto;
      padding: 20px 30px;
      border: 1px dashed #002F42;
      background-color: #fff;
      border-radius: 10px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
      transition: all .3s ease;
    }

  }
.modal-body {
  margin: 0px;
  padding: 10px;
}
.modal-header .sub-heading {
  background-color: #FFF;
 }
.modal-header {
  padding: 5px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.history-table-wrapper {
  height: 350px;
  overflow-y: auto;
}
.modal-footer {
  border-top: none;
}
.modal-title {
  font-size: 14px;
  font-weight: 900;
}
.modal-header {
  border-bottom: 0px;
  margin-bottom: 10px;
}
.modal-body {
  padding: 5px;
}
.ma-blue-btn {
  border-radius: 10px;
  width: 150px;
}
.closeBtn {
  width: 110px;
}
.form-control { font-size: 14px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
}
.reassign_options {
  margin-top: 1px;
}
.catalog-border {
    border: 1px solid #E2E2E2;
    border-radius: 7px;
    min-height: 55px;
    margin-top: 10px;
    padding-top: 15px;
    color: #71706F;
}
.cp-heading-title {
    font-size: 12px;
    padding-left: 35px;
    padding-top: 6px;
}

</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/pathway_builder_add_catalog_modal.vue